import { useEffect, useState } from "react";
import MaterialTable, { MTableBody, MTableToolbar } from "material-table";
import {
    Box,
    Grid,
    FormControl,
    CircularProgress,
    Typography
} from "@mui/material";
import { pdf } from "@react-pdf/renderer";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CloudDownloadOutlinedIcon from '@mui/icons-material/CloudDownloadOutlined';
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import { convertBase64, ConvertDateTime, s3Client } from "../../../../Base/helper/baseFunctions";
import NewPaySlip from "../../Employee/NewPaySlip";
import CommonDatePicker from "../../../../Base/views/CommonDatePicker";
import { GetDailyWagesEmployeePaySlipHelper } from "../../../helper/PaySlipHelper";
import { GetObjectCommand } from "@aws-sdk/client-s3";
import { getSignedUrl } from "@aws-sdk/s3-request-presigner";
import { GetCompanyLogoHelper } from "../../../../Ancillary/CompanyDetails/helper/CompanyDetailsHelper";
import { ShareAttachHelper } from "../../../helper/AttachmentHelper";
import { GetLetterHeadAction } from "../../../../../../store/Ancillary/LetterHead/Action";
import { GetDailyWageReportAction} from "../../../../../../store/Finance/Reports/Action";
import { useTheme, useMediaQuery } from "@mui/material";
import SelectableMultiSelect from "../../../../Base/views/SelectableMultiSelect";
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import Popup from "../../../../Base/views/Popup";

const PaySlipWorkBasedGrid = () => {
    const dispatch = useDispatch();
    const theme = useTheme();
    const isLarge = useMediaQuery(theme.breakpoints.only("lg"));
    const date = new Date();
    const [filters, setFilters] = useState({
        month_year: `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`,
        ats_work_location_id: []
    });
    const { minDojYear } = useSelector(state => state?.AncillaryReducer?.WorkSpaceDojReducer);
  const { isLoading, daily_wage_report_data } = useSelector(
    (state) => state?.FinanceReducer.WageReportsReducer
  );
    const { workLocationAccess_options } = useSelector(state => state?.AncillaryReducer?.WorkLocationReducer);
    const selectedDate = new Date(filters.month_year);
    const [name, setName] = useState(selectedDate.toLocaleString('default', { month: 'short', year: 'numeric' }));
    const [loadingRowId, setLoadingRowId] = useState(null);
    const [loadingviewRowId, setViewLoadingRowId] = useState(null);
    const [loadingEmailRowId, setLoadingEmailRowId] = useState(null);
    const { letterHeadData } = useSelector(state => state?.AncillaryReducer?.LetterHeadReducer);
    const [imageUrl, setImageUrl] = useState("");
    const [errorPopup, setErrorPopup] = useState({ open: false, message: "" });

    useEffect(() => {
        GetCompanyLogoHelper().then((res) => {
            res?.data?.data?.[0]?.companylogo && getImageSignedUrl(res?.data?.data?.[0]?.companylogo);
        })
            .catch((err) => {
                console.log(err);
            });
        dispatch(GetLetterHeadAction());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch]);
     useEffect(() => {
        const [f_year, month] = filters?.month_year?.split("-");
        const f_month = parseInt(month, 10).toString();
        const locationPayload = JSON.stringify((filters?.ats_work_location_id || [])?.map((item) => ({ ats_work_location_id: item?.work_location_id })));
        dispatch(GetDailyWageReportAction({ month: f_month, year: f_year,
                        location: (filters?.ats_work_location_id || [])?.length > 0 ? locationPayload : null 
         }));
         // eslint-disable-next-line react-hooks/exhaustive-deps
    },[filters])
    const [worklocationData, setWorklocationData] = useState({
                load: true,
                values: [],
            });
    const handleWorkLoacation = () => {
        if(workLocationAccess_options) {
            setWorklocationData({ load: false, values: workLocationAccess_options || [] })
        } else {
            setWorklocationData({ load: false, values: [] })
        }
    }
    useEffect(() => {
        handleWorkLoacation();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[workLocationAccess_options])
    const handleFilterChange = (event, value) => {
        if (["ats_work_location_id"].includes(event)) {
        if (value) {
            setFilters({ ...filters, [event]: value });
        } else {
            setFilters({ ...filters, [event]: "" });
        }
        }
    }
    const handleFilter = (event) => {
        if (["month_year"].includes(event?.target?.name)) {
            const updatedFilters = { ...filters, [event?.target?.name]: event?.target?.value };
            setFilters(updatedFilters);
            
            // Extract and set the new name
            const selectedDate = new Date(updatedFilters.month_year);
            const formattedName = selectedDate.toLocaleString("default", {
                month: "short",
                year: "numeric",
            });
            setName(formattedName);
        }
    };
    const Base64 = async (blob) => {
        return await convertBase64(blob);
    };
    const handleSendEmail = async (rowData) => {
        setLoadingEmailRowId(rowData.employee_fk); // Show loader for this row
        const selectedDate = new Date(filters.month_year);
        setName(selectedDate.toLocaleString('default', { month: 'short', year: 'numeric' }));
        const [f_year, month] = filters.month_year.split("-");
        const f_month = parseInt(month, 10).toString();
        try {
            const res = await GetDailyWagesEmployeePaySlipHelper({
                employee_id: rowData?.employee_fk,
                month: f_month,
                year: f_year,
            });
            if (res?.data?.data?.[0]) {
                const MyDocument = <NewPaySlip data={res?.data?.data?.[0]} imageUrl={imageUrl} letterHeadData={letterHeadData?.[0]} />;
                const pdfBlob = await pdf(MyDocument).toBlob();
                const base64Pdf = await Base64(pdfBlob);
                await ShareAttachHelper({
                    to: rowData?.office_email,
                    subject: `Pay Slip of ${name}`,
                    content: `Check Your ${name} Pay Slip`,
                    invoice_file: base64Pdf,
                    file_name: `${rowData?.employee_no} - ${name}.pdf`,
                    csv_file: "",
                    csv_file_name: "",
                    message: "Pay Slip Sent Successfully",
                });
            }
            if (res?.data?.error?.[0]?.message === "Payroll has not been generated for this employee for selected month. Head to Pay Summary Report to generate payroll") {
                setErrorPopup({ open: true, message: res?.data?.error?.[0]?.message });
            }
        } catch (error) {
            console.error("Error sending email:", error);
        } finally {
            setLoadingEmailRowId(null);
        }
    };

    const handleDownloadPDF = async (rowData) => {
        setLoadingRowId(rowData.employee_fk);
        const selectedDate = new Date(filters.month_year);
        setName(selectedDate.toLocaleString('default', { month: 'short', year: 'numeric' }));
        const [f_year, month] = filters.month_year.split("-");
        const f_month = parseInt(month, 10).toString();
        try {
            const res = await GetDailyWagesEmployeePaySlipHelper({
                employee_id: rowData?.employee_fk,
                month: f_month,
                year: f_year
            });

            if (res?.data?.data?.[0]) {
                const MyDocument = <NewPaySlip data={res?.data?.data?.[0]} imageUrl={imageUrl} letterHeadData={letterHeadData?.[0]}/>;
                const blob = await pdf(MyDocument).toBlob();
                const url = URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = `${rowData?.employee_no} - ${name}.pdf`;
                a.click();
                URL.revokeObjectURL(url);
            }
            if (res?.data?.error?.[0]?.message === "Payroll has not been generated for this employee for selected month. Head to Pay Summary Report to generate payroll") {
                setErrorPopup({ open: true, message: res?.data?.error?.[0]?.message });
            }
        } catch (error) {
            console.error("Error generating the PDF:", error);
        } finally {
            setLoadingRowId(null);
        }
    };
    const handleViewPaySlip = async (rowData) => {
        setViewLoadingRowId(rowData.employee_fk);
        const [f_year, month] = filters.month_year.split("-");
        const f_month = parseInt(month, 10).toString();

        try {
            const res = await GetDailyWagesEmployeePaySlipHelper({
                employee_id: rowData?.employee_fk,
                month: f_month,
                year: f_year,
            });

            if (res?.data?.data?.[0]) {
                const MyDocument = <NewPaySlip data={res.data.data[0]} imageUrl={imageUrl} letterHeadData={letterHeadData?.[0]}/>;
                const blob = await pdf(MyDocument).toBlob();
                const fileName = `${rowData?.employee_no} - ${name}.pdf`;
                const file = new File([blob], fileName, { type: "application/pdf" });
                const url = URL.createObjectURL(file);
                const newWindow = window.open(url, '_blank');
                if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
                    alert('Please allow popups for this site to view the payslip');
                }
            }
            if (res?.data?.error?.[0]?.message === "Payroll has not been generated for this employee for selected month. Head to Pay Summary Report to generate payroll") {
                setErrorPopup({ open: true, message: res?.data?.error?.[0]?.message });
            }
        } catch (error) {
            console.error("Error generating PDF:", error);
        } finally {
            setViewLoadingRowId(null);
        }
    };
    const getImageSignedUrl = async (currentData) => {
        let filename = currentData;
        const bucketParams = {
            Bucket: process.env.REACT_APP_DO_BUCKET_NAME,
            Key: filename,
        };
        const expiresIn = 604800;
        try {
            const url = await getSignedUrl(
                s3Client,
                new GetObjectCommand(bucketParams),
                { expiresIn }
            ); // Adjustable expiration.
            setImageUrl(url); // This will update the imageUrl state
            return url;
        } catch (err) {
            console.error("Error fetching image URL", err);
        }
    };

    return (
        <>
            <Box sx={{ maxHeight: "calc(100vh - 165px)", overflowY: "auto", }}>
                <Box sx={{ m: 1, mt: 2 }}>
                    <Grid sx={{ display: "flex", justifyContent: "space-between" }} container columnSpacing={1} mb={1}>
                        <FormControl>
                            <CommonDatePicker
                                name="month_year"
                                openTo="month"
                                views={['year', 'month']}
                                label="Month and Year"
                                pickerType="date"
                                size="small"
                                onKeyDown={(e) => e.preventDefault()}
                                onKeyPress={(e) => e.preventDefault()}
                                pickerFormat="MM/yyyy"
                                DefaultDTvalue={filters.month_year}
                                maxDate={new Date()}
                                // minDate={new Date(minDojYear)}
                                minDate={new Date(new Date(minDojYear).setFullYear(new Date(minDojYear).getFullYear() - 1))}
                                handleChange={(value) =>
                                    handleFilter({
                                        target: {
                                            name: "month_year",
                                            value: value
                                                ? `${value?.getFullYear()}-${("0" + (value?.getMonth() + 1)).slice(-2)}-${("0" + value?.getDate()).slice(-2)}`
                                                : "",
                                        },
                                    })
                                }
                            />
                        </FormControl>
                    </Grid>
                </Box>

                <MaterialTable
                    isLoading={isLoading}
                    columns={[
                        {
                            title: "Name",
                            cellStyle: { padding: "10px 10px 5px 13px" },
                            headerStyle: { cursor: "pointer" },
                            field: "employee_name",
                            grouping: false,
                        },
                        {
                            title: "Email",
                            cellStyle: { padding: "10px 10px 5px 13px" },
                            headerStyle: { cursor: "pointer" },
                            field: "office_email",
                            grouping: false,
                        },
                        {
                            title: "Work Location",
                            field: "work_location_name",
                            cellStyle: { padding: "10px 10px 5px 13px" },
                            headerStyle: { cursor: "pointer" },
                            grouping: false,
                            render: (rowData) => rowData?.work_location_name || "N/A"
                        },
                        {
                            title: "Joining Date",
                            cellStyle: { padding: "10px 10px 5px 13px" },
                            headerStyle: { cursor: "pointer" },
                            field: "doj",
                            render: (rowData) => {
                                return ConvertDateTime(rowData.doj);
                            },
                        },
                        {
                            title: "Payroll Setup", field: "payroll_setup_flag", 
                            headerStyle: { textAlign: "left", cursor: "default" }, 
                            cellStyle: { padding: "10px 10px 5px 35px", textAlign: "left" },
                            sorting: false,
                            render: rowData => {
                                return rowData.payroll_setup_flag ? <TaskAltIcon onClick={(e) => {e.stopPropagation()}} sx={{ color: "rgb(86, 202, 0)", cursor: 'default' }} />
                                    : <HighlightOffIcon onClick={(e) => {e.stopPropagation()}} sx={{ color: "rgb(255, 76, 81)", cursor: 'default' }} />
                            }
                        },
                        {
                            title: "View PaySlip",
                            field: "payroll_setup_flag",
                            headerStyle: { textAlign: "left", cursor: "default" },
                            cellStyle: { padding: "10px 10px 5px 35px", textAlign: "left" },
                            sorting: false,
                            render: (rowData) => {
                                return loadingviewRowId === rowData.employee_fk ? (
                                    <CircularProgress size={20} />
                                ) : (
                                    <VisibilityIcon
                                        sx={{ cursor: "pointer" }}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleViewPaySlip(rowData);
                                        }}
                                    />
                                );
                            },
                        },
                        {
                            title: "Download PaySlip", field: "payroll_setup_flag", 
                            headerStyle: { textAlign: "left", cursor: "default" }, 
                            cellStyle: { padding: "10px 10px 5px 45px", textAlign: "left" },
                            sorting: false,
                            render: (rowData) => {
                                return loadingRowId === rowData.employee_fk ? (
                                    <CircularProgress size={20} />
                                ) : (
                                    <CloudDownloadOutlinedIcon
                                        sx={{ cursor: "pointer" }}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleDownloadPDF(rowData);
                                        }}
                                    />
                                );
                            },
                        },
                        {
                            title: "Send Email",
                            field: "payroll_setup_flag",
                            headerStyle: { textAlign: "left", cursor: "default" },
                            cellStyle: { padding: "10px 10px 5px 35px", textAlign: "left" },
                            sorting: false,
                            render: (rowData) => {
                                return loadingEmailRowId === rowData.employee_fk ? (
                                    <CircularProgress size={20} />
                                ) : (
                                    <ForwardToInboxIcon
                                        sx={{ cursor: "pointer" }}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleSendEmail(rowData);
                                        }}
                                    />
                                );
                            },
                        }
                    ]}
                    data={ daily_wage_report_data || []}
                    options={{
                        maxBodyHeight: !isLarge ? "calc(100vh - 350px)" : "calc(100vh - 300px)",
                        minBodyHeight: !isLarge ? "calc(100vh - 350px)" : "calc(100vh - 300px)",
                        rowStyle: { fontSize: "13px" },
                        headerStyle: { padding: "10px 10px 5px 13px", fontWeight: "bold" },
                        sorting: true,
                        search: true,
                        searchText: "",
                        searchFieldAlignment: "right",
                        searchAutoFocus: true,
                        searchFieldVariant: "standard",
                        filtering: false,
                        paging: true,
                        pageSizeOptions: [25, 50],
                        pageSize: 25,
                        paginationType: "stepped",
                        showFirstLastPageButtons: false,
                        paginationPosition: "bottom",
                        exportButton: false,
                        exportAllData: false,
                        exportFileName: "Employees",
                        addRowPosition: "first",
                        selection: false,
                        actionsColumnIndex: -1,
                        showSelectAllCheckbox: true,
                        showTextRowsSelected: true,
                        grouping: false,
                        columnsButton: false,
                    }}
                        components={{
                            Body: props => 
                            daily_wage_report_data?.length === 0 ? (
                                <tbody>
                                <tr>
                                    <td colSpan={props.columns.length}>
                                    <Box
                                        sx={{
                                        height: !isLarge ? "calc(100vh - 350px)" : "calc(100vh - 300px)",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        color: "#888",
                                        fontSize: "16px",
                                        }}
                                    >
                                    Pay summary not generated for this month-year selection. Please generate it before proceeding.
                                </Box>
                                    </td>
                                </tr>
                                </tbody>
                            ) : (
                                <MTableBody {...props} />
                            ),
                            Toolbar: (props) => (
                            <Box sx={{ width: "full", display: "flex", flexDirection: { xs: "column", sm: "row" }, flexGrow: 1 }}>
                                <Box
                                    sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    backgroundColor: "#f3edfd",
                                    padding: "0px 0px 0px 20px",
                                    flexGrow: 1,
                                    minHeight: "48px !important",
                                    }}
                                >
                                <Box>
                                    <Typography variant='h6'>
                                        Employee
                                    </Typography>
                                </Box>
                                <Box sx={{width: "210px", display: "flex", alignItems: "center", pt: 0.5}}>
                                    <SelectableMultiSelect
                                        multiple
                                        label="Work Location"
                                        placeholder="Select Location"
                                        value={filters?.ats_work_location_id}
                                        loading={handleWorkLoacation}
                                        fieldLabel="work_location_name"
                                        name="ats_work_location_id"
                                        size="small"
                                        onChangeEvent={handleFilterChange}
                                        data={worklocationData}
                                        menuHeight={150} // optional
                                    />
                                </Box> 
                                </Box>
                                <Box
                                    sx={{
                                        "& .MuiToolbar-root": {
                                        padding: "12px 16px !important",
                                        margin: "auto !important",
                                        minHeight: "48px !important",
                                        },
                                        "& .MuiFormControl-root": {
                                        margin: "0 !important",
                                        },
                                        "& .MuiInputBase-root": {
                                        marginLeft: "-20px !important",
                                        }
                                    }}
                                    >
                                        <MTableToolbar {...props} />
                                    </Box>
                                </Box>
                        ),
                      }}
                    title=""
                />
                <Popup
                    title={
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <WarningAmberIcon color="warning" fontSize="small" />
                            Alert
                        </Box>
                    }
                    openPopup={errorPopup?.open}
                    setOpenPopup={(value) => setErrorPopup((prev) => ({ ...prev, open: value }))}
                    maxWidth="sm"
                >
                    <Typography>{errorPopup?.message}</Typography>
                </Popup>
            </Box>
        </>
    );
};

export default PaySlipWorkBasedGrid;